import { Spinner } from '@tempmee/react';
import { Center, Column, Pagination } from '~/commonComponents';
import { useOnsiteInterviewTabView } from './useOnsiteInterviewTabView';
import { OnsiteInterviewStatusFilterPanel } from '~/components/PermanentJobsV2/components';
import { OnsiteInterviewListTable } from './OnsiteInterviewListTable';

interface IOnsiteInterviewTabViewProps {
  jobPostingId: string;
}

export const OnsiteInterviewTabView = ({ jobPostingId }: IOnsiteInterviewTabViewProps) => {
  const { data, filters, isInitialLoading, isLoading, methods, pagination, statistic } =
    useOnsiteInterviewTabView(jobPostingId);

  return (
    <Column paddingInline={80}>
      <OnsiteInterviewStatusFilterPanel counts={statistic} onChange={methods.setStatusFilter} />
      {isInitialLoading ? (
        <Center marginBlock={32}>
          <Spinner centered variant="default" size="md" />
        </Center>
      ) : (
        <>
          <OnsiteInterviewListTable
            data={data}
            jobPostingId={jobPostingId}
            isLoading={isLoading}
            isShowStatusSorting={filters.status === 'all'}
            sorting={filters.sorting}
            status={filters.status}
            onSortingChange={methods.setSorting}
          />
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={methods.setCurrentPage}
          />
        </>
      )}
    </Column>
  );
};
